export type FilterType = "region" | "year" | "genre";

interface Props {
  regionOptions: string[];
  yearOptions: string[];
  genreOptions: string[];
  selected: { region: string[]; year: string[]; genre: string[] };
  onToggle: (type: FilterType, value: string) => void;
  onClear: () => void;
}

const groupTitles: Record<FilterType, string> = {
  region: "地区",
  year: "年份",
  genre: "类型",
};

export default function FilterSidebar({
  regionOptions,
  yearOptions,
  genreOptions,
  selected,
  onToggle,
  onClear,
}: Props) {
  const groups: { type: FilterType; options: string[] }[] = [
    { type: "region", options: regionOptions },
    { type: "year", options: yearOptions },
    { type: "genre", options: genreOptions },
  ];

  const activeCount = selected.region.length + selected.year.length + selected.genre.length;

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-sm font-semibold text-foreground-900 font-heading flex items-center gap-2">
          <i className="ri-filter-3-line text-accent-500 text-base" />
          筛选条件
        </h2>
        <button
          type="button"
          onClick={onClear}
          disabled={activeCount === 0}
          className="text-xs text-foreground-500 hover:text-accent-600 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer whitespace-nowrap"
        >
          清空筛选
        </button>
      </div>

      <div className="flex flex-col gap-5">
        {groups.map((group) => (
          <div key={group.type}>
            <p className="mb-2.5 text-xs font-medium text-foreground-500">{groupTitles[group.type]}</p>
            <div className="flex flex-wrap gap-2">
              {group.options.map((opt) => {
                const isActive = selected[group.type].includes(opt);
                return (
                  <button
                    key={opt}
                    type="button"
                    onClick={() => onToggle(group.type, opt)}
                    className={`rounded-full px-3 py-1.5 text-xs transition-colors cursor-pointer whitespace-nowrap ${
                      isActive
                        ? "bg-primary-600 text-background-50"
                        : "bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-700"
                    }`}
                  >
                    {opt}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}